import {Component, Inject, Input, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormModel} from '../../../common/components/form/models';
import {LdapUser} from '@Services/ldap/ldap/ldap-user.model';
import {SubSink} from '@Common/core/utils/subsink';
import {FormulaireService} from '../../../common/services/formulaire/formulaire.service';
import {SnackBarToastyService, typeToast} from '@Common/widgets/general/snack-bar';
import {finalize} from 'rxjs/operators';

@Component({
  selector: 'app-gestionnaires-formulaire',
  templateUrl: './gestionnaires-formulaire.component.html',
  styleUrls: ['./gestionnaires-formulaire.component.scss']
})
export class GestionnairesFormulaireComponent implements OnInit, OnDestroy {
  /**
   * Options de recherche
   */
  @Input() scope = false;
  @Input() defaultScopes = '';
  @Input() scopesToDisplay = ['employee', 'faculty', 'researcher', 'student'];
  onProcess = false;
  subSink = new SubSink();

  constructor(@Inject(MAT_DIALOG_DATA) public data: FormModel,
              public dialogRef: MatDialogRef<GestionnairesFormulaireComponent>,
              private formSvc: FormulaireService,
              private snackSvc: SnackBarToastyService) {
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onSelectIndiv(ldapUser: LdapUser) {
    this.onProcess = true;
    const uid = ldapUser.uid[0];
    this.subSink.sink = this.formSvc
      .addFormGestionnaire(this.data, uid)
      .pipe(finalize(() => this.onProcess = false))
      .subscribe(
      (form: FormModel) => {
        this.formLoaded(form);
        this.snackSvc.toasty('Gestionnaire',
          `Le gestionnaire ${ldapUser?.displayName} a bien été ajouté au formulaire "${form.nom}"`,
          typeToast.success);
      }
    );
  }

  formLoaded(form: FormModel) {
    this.data = form;
  }
}
